/// <reference types="@types/google.maps" />

import { Ajax, Storage } from 'rustig';
import { ExtendedBoundsRenderer } from './extendedboundsrenderer';
import { ZoomLevel } from './marker';

export class CountyOverlay {

  map: google.maps.Map;
  counties: Array<County>;
  maxZoom: number;
  scale: number;
  extendedBounds: google.maps.LatLngBounds;
  previousZoom: number;
  isEnabled: boolean;

  public constructor(map: google.maps.Map, maxZoom: number, scale: number) {
    this.map = map;
    this.maxZoom = maxZoom;
    this.scale = scale;
    this.previousZoom = 20;
      this.isEnabled = true;

    this.loadCounties();
    google.maps.event.addListener(this.map, 'bounds_changed', this.redraw.bind(this));
  }

  public enable(): void {
    this.isEnabled = true;
    this.redraw();
  }

  public disable(): void {
    this.isEnabled = false;
    this.redraw();
  }

  loadCounties(): void {
    let countiesJson = Storage.get('cp-counties');

    if (countiesJson && this.isJson(countiesJson)) {
      this.counties = this.buildCounties(countiesJson);
      this.redraw();
    }
    else {
      this.counties = new Array<County>();
      let self = this;
      Ajax.execute({
        url: '/county/lines',
        success: function (data) {
          Storage.set('cp-counties', data);
          self.counties = self.buildCounties(data);
          self.redraw();
        }
      });
    }
  }

  isJson(json: string): boolean {
    try {
      JSON.parse(json);
    }
    catch (e) {
      return false;
    }
    return true;
  }

  buildCounties(countiesJson: string): Array<County> {
    let counties = JSON.parse(countiesJson);

    return counties.map(function (county) {
      let center = new google.maps.LatLng(county.Center.Latitude, county.Center.Longitude);
      let boundaries = county.Boundaries.map(x => google.maps.geometry.encoding.decodePath(x));

      return new County(county.Name, center, boundaries);
    });
  }

  redraw(): void {
      if (!this.counties.length)
        return;

    let zoom = this.map.getZoom();
    if (zoom < this.maxZoom || !this.isEnabled) {
      this.counties.forEach(x => x.setMap(null));
      this.extendedBounds = null;
      return;
    }

    let bounds = this.map.getBounds();
    if (!bounds)
      return;
    let mapWasZoomedOutOrZoomNotChanged = zoom <= this.previousZoom;
    let extendedBoundsContainsTheCurrentBounds = ExtendedBoundsRenderer.extendedBoundsContainBounds(this.extendedBounds, bounds);
    if (mapWasZoomedOutOrZoomNotChanged && extendedBoundsContainsTheCurrentBounds) {
      this.previousZoom = zoom;
      return;
    }

    this.previousZoom = zoom;
    this.extendedBounds = ExtendedBoundsRenderer.extendBounds(this.map.getBounds(), this.scale);
    this.counties.forEach(x => x.setMap(x.intersects(this.extendedBounds) ? this.map : null));
  }
}

class County {
  lines: Array<google.maps.Polyline>;
  center: google.maps.marker.AdvancedMarkerElement;
  bounds: google.maps.LatLngBounds;

  constructor(name: string, center: google.maps.LatLng, boundaries: Array<google.maps.LatLng[]>) {
    let nameElement = document.createElement('span');
    nameElement.textContent = name;
    nameElement.style['fontWeight'] = 'bold';
    nameElement.style['fontSize'] = '16px';

    this.center = new google.maps.marker.AdvancedMarkerElement({
      position: center,
      content: nameElement,
      zIndex: 1000,
    });

    this.bounds = this.buildBounds(boundaries);
    this.lines = boundaries.map(x => new google.maps.Polyline({
      path: x,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 1
    }));
  }

  public setMap(map: google.maps.Map): void {
    if (map && map.getZoom() >= ZoomLevel.County)
      this.center.map = map;
    else
      this.center.map = null;
    this.lines.forEach(x => x.setMap(map));
  }

  public intersects(bounds: google.maps.LatLngBounds): boolean {
    return this.bounds.intersects(bounds);
  }

  buildBounds(boundaries: Array<google.maps.LatLng[]>) {
    let north = -90;
    let south = 90;
    let west = 180;
    let east = -180;

    for (var i = 0; i < boundaries.length; i++) {
      for (var j = 0; j < boundaries[i].length; j++) {

        let lat = boundaries[i][j].lat();
        let long = boundaries[i][j].lng();
        if (lat > north)
          north = lat;
        if (lat < south)
          south = lat;
        if (long > east)
          east = long;
        if (long < west)
          west = long;
      }
    }

    return new google.maps.LatLngBounds(new google.maps.LatLng(south, west), new google.maps.LatLng(north, east));
  }
}
